import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Acupuncture = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my acupuncture business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps acupuncture businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for acupuncture businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most acupuncture businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my acupuncture business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like acupuncture. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Acupuncture - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Acupuncture CRM", url: "/industries/acupuncture" }
  ];

  const industryData = {
    name: 'Acupuncture Clinic',
    title: 'Fill Your Practice & Build Long-Term Wellness Clients',
    subtitle: 'Automate appointment booking, track treatment plans, and convert first-time patients into wellness maintenance clients',
    icon: '🎯',
    challenges: [
      'New patients don\'t return after initial treatment',
      'Hard to educate patients on treatment series',
      'High no-show rates affect revenue',
      'Difficult to schedule regular maintenance',
      'Insurance pre-authorization is time-consuming'
    ],
    solutions: [
      'Automated treatment series education',
      'Multi-visit package promotion',
      'Appointment reminder automation',
      'Wellness maintenance scheduling',
      'Insurance verification tracking'
    ],
    features: [
      'Patient CRM with condition tracking',
      'Treatment plan management',
      'Automated appointment reminders',
      'Package and wellness program tracking',
      'Educational content delivery',
      'Insurance coordination',
      'Online booking',
      'Review automation'
    ],
    results: [
      '70% convert to treatment series',
      '60% become wellness maintenance clients',
      '40% reduction in no-shows',
      '£4.9K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Acupuncture UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for acupuncture businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for acupuncture UK, acupuncture business software, acupuncture customer management, acupuncture lead generation UK"
        url="/industries/acupuncture"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Acupuncture;